<template>
  <div>
    <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="24">
          <div class="title">
            广州国际分析测试及实验室设备展览会暨技术研讨会展商报名 / CHINA LAB
            Exhibitor registration
          </div>
        </Col>
        <!-- <Col span="12" class="f-tar">
        <Button shape="circle" style="border-color:#00a0e9;color:#00a0e9;">中文</Button>
        <Button shape="circle" style="margin-left:10px" @click="$router.push(`/ex-register-en/register`)">English</Button>
        </Col> -->
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="tip-info" style="margin-top: 700px">
        <p>注：</p>
        <p>1.二、三类及升级展区，转角展位加RMB 530元/个1</p>
        <p>
          2.标准展位规格为3mX3m，光地仅限特装企业，光地起租面积为18平方米起，且为9的倍数
        </p>
        <p>3.展位价格含税，开具增值税专用发票</p>
        <p>4.展商可凭发票向当地税局申请全额抵扣6%的增值税费</p>
        <p>Notes</p>
        <p>
          1. An additional RMB 530 will be charged for any Type II, Type III or
          upgraded area booth located at the corner
        </p>
        <p>
          2. The standard booth size is 3m x 3m, and the raw space can only be
          booked by companies requiring a special booth design, The minimum
          rental area for bare land is 18 square meters, which is a multiple of
          9.
        </p>
        <p>
          3. The booth price includes tax, as will be specified in a VAT invoice
        </p>
        <p>
          4. Exhibitors can use the invoice to apply for a deduction of 6% VAT
          at local tax authorities
        </p>
      </div>

      <div class="f-tac submit-btn">
        <Button
          type="primary"
          size="large"
          @click="handleSubmit"
          :loading="loading"
          >确定以上信息，并提交展位申请
          <p>
            Determine the above information and submit the booth application
          </p>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerAddr from "./components/register-addr.vue";
import common from "@/utils/common";
import config from "@assets/config.json";
import axios from "axios";
import { MD5 } from "crypto-js";
export default {
  name: "register",
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  props: {},
  data() {
    return {
      loading: false,
      arr: [
        {
          id: 1,
          path: "https://api.chinalabexpo.com/exhibitor-form-management/file-system/file/202405/20240510/4zpn33d24cj4nvzeyt7aspv0mp.png",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: "registerdModule/getApplyCompanyRoastCreate", // 新增展会接口
    }),
    // 获取token
    async token(opt, res) {
      try {
        const params = new URLSearchParams();
        params.append("client_id", "MYDev-vokDwKQxhN5NHpX8DhWwQmldAK9Yb9");
        params.append("client_secret", "crOmK3BV8pzjkYNgW7a5ryMnOYpCOM2uO9jh");
        params.append("grant_type", "client_credentials");
        params.append("scope", "open_api");

        const response = await axios.post(
          "https://api-ecrm.reed-sinopharm.com/connect/token",
          params,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.access_token) {
          this.tokens = response.data.access_token;
          this.myOtherCreate(opt, res);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log("registerForm", res);
      console.log("registerAddr", res2);
      let opt = {
        newCompany: { ...res.form },
        lists: [
          {
            exhibitionId: "12395618-C8B3-45C1-8216-D7A87407B884",
            ...res2.ApplyCompanyOrder,
          },
        ],
        reportType: "cn",
      };
      let exname = "";
      res2.exhibition.forEach((c, index) => {
        exname += c.nameEn || "FIBO CHINA 2022";
        if (res2.exhibition.length !== index + 1) {
          exname += ",";
        }
      });
      console.log("option", opt);
      // this.token(opt, res)
      let bool = await this.getApplyCompanyRoastCreate(opt);
      this.loading = false;
      console.log("getApplyCompanyRoastCreate", bool);
      if (bool && bool.successed) {
        let query =
          "company=" +
          encodeURI(res.form.companyName) +
          "&exname=" +
          encodeURI(exname);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }
    },
    // 提交到慕渊云
    async myOtherCreate(opt, res) {
      const xAdprvClientId = "MYDev-vokDwKQxhN5NHpX8DhWwQmldAK9Yb9";
      const xAdprvClientSecret = "36R8J/zNyWvAHxlnEQhp6ydd1xzVu98ESvdG2pjg4A0=";
      const noncestr = common.getRandomString(6);
      const timer = common.getUTCTimestampInSeconds();

      const sign = `x-adprv-client-id=${xAdprvClientId}\\\\x-adprv-client-secret=${xAdprvClientSecret}\\\\x-adprv-noncestr=${noncestr}\\\\x-adprv-timestamp=${timer}`;
      const signMd5 = MD5(sign).toString();
      const address = {
        country: opt.newCompany.country,
        province: opt.newCompany.province,
        city: opt.newCompany.city,
        county: "",
        details: opt.newCompany.address,
        postcode: opt.newCompany.postcode,
      };
      const contacts = [
        {
          kind: "展会联系人",
          name: opt.newCompany.linkMan,
          jobTitle: opt.newCompany.linkTitle,
          phoneNumber: opt.newCompany.linkMob,
          email: opt.newCompany.linkEmail,
          tel: {
            countryCode: "",
            areaCode: opt.newCompany.linkCode || "",
            code: opt.newCompany.linkTelephone || "",
            subcode: "",
          },
          qq: opt.newCompany.linkQQ,
          weChat: opt.newCompany.linkWeChat,
        },
        {
          kind: "市场部负责人",
          name: opt.newCompany.leader,
          jobTitle: opt.newCompany.leaderTitle,
          phoneNumber: opt.newCompany.leaderMob,
          email: opt.newCompany.leaderEmail,
          tel: {
            countryCode: "",
            areaCode: opt.newCompany.LeaderCode || "",
            code: opt.newCompany.leaderTelephone || "",
            subcode: "",
          },
          qq: opt.newCompany.leaderQQ,
          weChat: opt.newCompany.leaderWeChat,
        },
      ];
      const deliveryAddress = {
        country: opt.newCompany.invoiceMalingCountry,
        province: opt.newCompany.invoiceMalingProvince,
        city: opt.newCompany.invoiceMalingCity,
        county: "",
        details: opt.newCompany.invoiceMalingAdress,
        postcode: opt.newCompany.invoiceMalingCode,
      };
      const booths = [];
      opt.lists.forEach((value, index) => {
        if (index == 0) {
          booths.push({
            exhibitionId: "3dcec582-1c63-adc4-5380-3a16545b0c5a",
            kind: value.areaType == "光地" ? "特装" : "标展",
            name: value.areaName,
            num: value.showArea,
            hall: "",
          });
        }
      });
      const response = await axios.post(
        `${config.apiMy.reqApi}/api/v1/intention/CMEFOtherCreate`,
        {
          name: opt.newCompany.companyName,
          nameEn: opt.newCompany.companyNameEn,
          shortNameEn: "",
          shortName: opt.newCompany.companyNameShort,
          unicode: opt.newCompany.unifiedCode,
          address: address,
          addressEn: "",
          attachmentBusinessLicenseImgUrl: opt.newCompany.imgBusinessLicense
            ? JSON.parse(opt.newCompany.imgBusinessLicense).url
            : "",
          website: opt.newCompany.website,
          fax: opt.newCompany.linkFax,
          invoiceDto: {
            lookUp: opt.newCompany.invoiceTitle,
            taxNumber: opt.newCompany.invoiceCode,
            address: opt.newCompany.invoiceAddress,
            bank: opt.newCompany.invoiceBank,
            bankAccount: opt.newCompany.invoiceBankAccount,
            tel: opt.newCompany.invoiceTelephone,
          },
          invoiceRemark: "",
          attachmentLogoUrl: "",
          contacts: contacts,
          booths: booths,
          specialFileds: {
            invoiceType: opt.newCompany.invoiceType,
            invoiceAddress: JSON.stringify(deliveryAddress),
            invoiceReveiver: opt.newCompany.invoiceRecivePerson,
            invoiceReveiverTel: opt.newCompany.invoiceReciveTel,
            isNeedActivity: opt.lists[0].isNeedActivity,
          },
          projectId: "b195a5f4-6d84-dcf9-28a3-3a16545b0c46",
          exhibitionId: "3dcec582-1c63-adc4-5380-3a16545b0c5a",
        },
        {
          headers: {
            "x-exhibition-id": "3dcec582-1c63-adc4-5380-3a16545b0c5a",
            "x-project-id": "b195a5f4-6d84-dcf9-28a3-3a16545b0c46",
            "content-type": "application/json",
            "x-adprv-noncestr": noncestr,
            "x-adprv-timestamp": timer,
            "x-adprv-sign": signMd5,
            Authorization: "Bearer " + this.tokens,
          },
        }
      );
    },
  },

  created() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.$router.push(`/ex-register/register-mobile`);
    }
  },
};
</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;

  .top {
    padding: 29px 0 40px;
  }

  .title {
    font-size: 26px;
    color: #333;
    font-weight: bold;
  }
}

.submit-btn {
  margin-top: 0px;
  text-align: center;

  button {
    padding: 0 46px;
    height: 48px;
    background-color: #00a0e9;
    font-size: 16px;
    border-color: #00a0e9;
    margin-bottom: 80px;
  }
}

.tip-info {
  width: 1200px;
  margin: 0 auto 116px;

  p {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
  }
}
</style>
